var map = {
	"./": 138,
	"./development": 328,
	"./development.js": 328,
	"./index": 138,
	"./index.js": 138,
	"./production": 329,
	"./production.js": 329,
	"./staging": 330,
	"./staging.js": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;